export default __webpack_public_path__ + "static/media/NewQuestionnaire.aea1b605.svg";